import {
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
  theme,
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useEffect, useState } from "react";
import Heading from "../../../../../components/common/heading";
const { useToken } = theme;

const { Title } = Typography;
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const BehaviorView = (props) => {
  const { token } = useToken();
  const [form] = Form.useForm();
  const [checkOther, setCheckOther] = useState(false);
  const { dataDetail, dropDownKnowChannel } = props;

  //   console.log("dropDownKnowChannel :: ", dropDownKnowChannel);

  const ListDataMock = [
    { name: "test1", value: "test1" },
    { name: "test2", value: "test2" },
    { name: "test3", value: "test3" },
    { name: "test4", value: "test4" },
    { name: "test5", value: "test5" },
    { name: "อื่นๆ", value: "other" },
  ];

  const onChange = (value) => {
    if (value === "other") {
      setCheckOther(true);
    } else {
      setCheckOther(false);
    }
  };



  return (
    <Content style={{ paddingTop: 15 }}>
      <Row gutter={[8, 16]} className="card">
        <Col span={24}>
          <Heading
            text={"บันทึกพฤติกรรมลูกค้า"}
            size={4}
            style={{ margin: 0, color: token.thPrimary }}
          />
          <Divider />
        </Col>

        {/* {dataDetail.futureCustomerBehavior?.map((item, index) => { */}
        {/* console.log(item);
                    return ( */}
        <>
          <Col span={16}>
            <Form.Item
              label={<Text className="pr_green">บันทึกพฤติกรรมลูกค้า</Text>}
              name={"customer_behavior"}
            >
              {dataDetail.futureCustomerBehavior ? (
                <>
                  {dataDetail.futureCustomerBehavior.length > 0 ? (
                    <>
                      {/* {dataDetail.futureCustomerBehavior[0]} */}
                      <Text>
                        {dataDetail.futureCustomerBehavior[0]
                          .customerBehavior !== ""
                          ? dataDetail.futureCustomerBehavior[0]
                              .customerBehavior
                          : "-"}
                      </Text>
                    </>
                  ) : (
                    <>
                      <Text>-</Text>
                    </>
                  )}
                </>
              ) : (
                <>
                  <Text>-</Text>
                </>
              )}
            </Form.Item>
          </Col>

          <Col span={16}>
            <Form.Item
              label={
                <Text className="pr_green">
                  ช่องทางรู้จักกับทาง กนอ. (ตอบได้มากกว่า 1 ข้อ)
                </Text>
              }
              name={"question1"}
            >
              {dataDetail.futureCustomerBehavior ? (
                <>
                  {dataDetail.futureCustomerBehavior.length > 0 ? (
                    <ul style={{ paddingLeft: 15 }}>
                      {dropDownKnowChannel.map((item) => {
                        for (
                          let index = 0;
                          index <
                          dataDetail.futureCustomerBehavior[0].channel?.length;
                          index++
                        ) {
                          const element =
                            dataDetail.futureCustomerBehavior[0].channel[index];
                          if (element === item.dataId) {
                            return (
                              <li key={item.dataId}>{item.dataDetailTh}</li>
                            );
                          }
                        }
                      })}
                    </ul>
                  ) : (
                    <Text>-</Text>
                  )}
                </>
              ) : (
                <>
                  <Text>-</Text>
                </>
              )}
            </Form.Item>
          </Col>
          {checkOther && (
            <>
              <Col span={16} style={{ paddingTop: 0 }}>
                <Form.Item name={"other_detail"}>
                  <Text>-</Text>
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={16}>
            <Form.Item
              label={
                <Text className="pr_green">
                  ข้อเสนอแนะช่องทางการสื่อสารและ
                  การให้บริการที่ลูกค้าใช้ในการติดต่อ{" "}
                </Text>
              }
              name={"suggestion"}
            >
              {dataDetail.futureCustomerBehavior ? (
                <>
                  {dataDetail.futureCustomerBehavior.length > 0 ? (
                    <>
                      <Text>
                        {dataDetail.futureCustomerBehavior[0].suggestion != ""
                          ? dataDetail.futureCustomerBehavior[0].suggestion
                          : "-"}
                      </Text>
                    </>
                  ) : (
                    <>
                      <Text>-</Text>
                    </>
                  )}
                </>
              ) : (
                <>
                  <Text>-</Text>
                </>
              )}
            </Form.Item>
          </Col>
        </>
        {/* ); */}
        {/* // })} */}
      </Row>
    </Content>
  );
};

export default BehaviorView;
